import React from 'react';
import { MapPin, MessageCircle } from 'lucide-react';
import { useT } from '../i18n/LanguageContext';

const boroughs = {
  central: ['Westminster', 'City of London', 'Camden', 'Islington', 'Kensington & Chelsea', 'Southwark', 'Lambeth'],
  north: ['Barnet', 'Enfield', 'Haringey', 'Harrow', 'Hackney', 'Waltham Forest'],
  south: ['Bromley', 'Croydon', 'Merton', 'Sutton', 'Wandsworth', 'Kingston upon Thames', 'Richmond upon Thames'],
  east: ['Barking & Dagenham', 'Bexley', 'Greenwich', 'Havering', 'Lewisham', 'Newham', 'Redbridge', 'Tower Hamlets'],
  west: ['Brent', 'Ealing', 'Hammersmith & Fulham', 'Hillingdon', 'Hounslow', 'Wembley'],
};

export default function Areas() {
  const { t } = useT();

  const zones = [
    { key: 'central', label: t('areas.central') },
    { key: 'north', label: t('areas.north') },
    { key: 'south', label: t('areas.south') },
    { key: 'east', label: t('areas.east') },
    { key: 'west', label: t('areas.west') },
  ];

  return (
    <section id="areas" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="uc-kicker mb-3">{t('areas.kicker')}</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1a2851]">
            {t('areas.heading1')} <span className="text-[#4dbfae]">{t('areas.heading2')}</span>
          </h2>
          <p className="text-[#5b6469] mt-4 max-w-2xl mx-auto">{t('areas.sub')}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4">
          {zones.map((z) => (
            <div
              key={z.key}
              className="uc-lift bg-[#f7fcfb] rounded-2xl p-5 border border-[#eef6f4]"
            >
              <div className="flex items-center gap-2 mb-3">
                <MapPin size={18} className="text-[#4dbfae]" />
                <h3 className="font-serif font-bold text-[#1a2851]">{z.label}</h3>
              </div>
              <ul className="space-y-1.5">
                {boroughs[z.key].map((b) => (
                  <li key={b} className="text-sm text-[#5b6469]">
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center">
          <a
            href="https://wa.me/447547340708?text=Hi%20GiCleanly!%20Do%20you%20cover%20my%20area%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#f2fbf9] border border-[#4dbfae]/30 rounded-full px-5 py-3 hover:bg-[#e6f7f4] transition-colors"
          >
            <span className="w-8 h-8 rounded-full bg-[#25D366] flex items-center justify-center text-white">
              <MessageCircle size={16} fill="white" strokeWidth={0} />
            </span>
            <span className="text-sm text-[#1a2851] font-medium">{t('areas.notSure')}</span>
          </a>
        </div>
      </div>
    </section>
  );
}
